import UserAvatar from "./UserAvatar";
import HamburgerButton from "./UI/HamburgerButton";
import SearchBar from "./UI/SearchBar";
import { Fragment, useContext, useEffect, useState } from "react";
import { ThemeContext } from "../context/ThemeContext";
import useWindowDimensions from "../hooks/useWindowDimensions";
import Bell from "./UI/Bell";
import ActivityList from "./ActivityList";
import { useSelector } from "react-redux";

function TopNavbar({ userName, icon, toggleSidebar, sidebarOpen }) {
  const { width } = useWindowDimensions()
  const theme = useContext(ThemeContext);
  const { dark } = theme;
  const notifications = useSelector((state) => state.notification.items);
  const [modalOpen, setModalOpen] = useState(false)

  const unread = [];
  useEffect(()=>{
    if(notifications!==undefined){
    if(notifications.count!==0){
    notifications.forEach(element => {
      if (element.read === false) {
        unread.push(element);
      }
    });
  }
  }
  },[notifications])

  const notifNumber = unread.length;

  function toggleModal() {
    setModalOpen(!modalOpen);
  }

  function activateSidebar() {
    toggleSidebar();
  }

  return (
    <Fragment>
      {modalOpen && <ActivityList toggleModal={toggleModal} elements={notifications} />}
      <header
        className={`fixed py-3 ${dark ? "bg-neutral-900" : "bg-white"
          } w-full top-0 shadow-md z-20 `}
      >
        <div className="container flex flex-wrap items-center justify-start w-full h-min">
          <div className="left-0 pl-4">
            <HamburgerButton onClick={activateSidebar} />
          </div>
          {sidebarOpen && <div className=" w-[12%]"></div>}
          <div className={`flex items-center pl-4 `}>
            <svg width="21" height="25" viewBox="0 0 21 25" className={`mr-3 fill-current ${dark ? "text-white" : "text-neutral-900"}`} xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M9.0501 2.3499C9.0501 1.96534 9.20286 1.59653 9.47479 1.3246C9.74672 1.05267 10.1155 0.899902 10.5001 0.899902C10.8847 0.899902 11.2535 1.05267 11.5254 1.3246C11.7973 1.59653 11.9501 1.96534 11.9501 2.3499V10.3249C11.9501 10.5172 12.0265 10.7016 12.1624 10.8376C12.2984 10.9735 12.4828 11.0499 12.6751 11.0499C12.8674 11.0499 13.0518 10.9735 13.1877 10.8376C13.3237 10.7016 13.4001 10.5172 13.4001 10.3249V3.7999C13.4001 3.41534 13.5529 3.04653 13.8248 2.7746C14.0967 2.50267 14.4655 2.3499 14.8501 2.3499C15.2347 2.3499 15.6035 2.50267 15.8754 2.7746C16.1473 3.04653 16.3001 3.41534 16.3001 3.7999V10.3249C16.3001 10.5172 16.3765 10.7016 16.5124 10.8376C16.6484 10.9735 16.8328 11.0499 17.0251 11.0499C17.2174 11.0499 17.4018 10.9735 17.5378 10.8376C17.6737 10.7016 17.7501 10.5172 17.7501 10.3249V6.6999C17.7501 6.31534 17.9029 5.94653 18.1748 5.6746C18.4467 5.40267 18.8155 5.2499 19.2001 5.2499C19.5847 5.2499 19.9535 5.40267 20.2254 5.6746C20.4973 5.94653 20.6501 6.31534 20.6501 6.6999V13.9499C20.6501 15.2828 20.3876 16.6027 19.8775 17.8341C19.3674 19.0656 18.6197 20.1845 17.6772 21.127C16.7347 22.0695 15.6158 22.8172 14.3843 23.3273C13.1529 23.8374 11.833 24.0999 10.5001 24.0999C9.16718 24.0999 7.84732 23.8374 6.61586 23.3273C5.38441 22.8172 4.26548 22.0695 3.32296 21.127C2.38045 20.1845 1.63281 19.0656 1.12272 17.8341C0.612635 16.6027 0.350098 15.2828 0.350098 13.9499V11.0499C0.350098 10.6653 0.502865 10.2965 0.774793 10.0246C1.04672 9.75267 1.41553 9.5999 1.8001 9.5999C2.18466 9.5999 2.55347 9.75267 2.8254 10.0246C3.09733 10.2965 3.2501 10.6653 3.2501 11.0499V14.6749C3.2501 14.8672 3.32648 15.0516 3.46245 15.1876C3.59841 15.3235 3.78282 15.3999 3.9751 15.3999C4.16738 15.3999 4.35179 15.3235 4.48775 15.1876C4.62371 15.0516 4.7001 14.8672 4.7001 14.6749V3.7999C4.7001 3.41534 4.85287 3.04653 5.12479 2.7746C5.39672 2.50267 5.76553 2.3499 6.1501 2.3499C6.53466 2.3499 6.90347 2.50267 7.1754 2.7746C7.44733 3.04653 7.6001 3.41534 7.6001 3.7999V10.3249C7.6001 10.5172 7.67648 10.7016 7.81244 10.8376C7.94841 10.9735 8.13282 11.0499 8.3251 11.0499C8.51738 11.0499 8.70179 10.9735 8.83775 10.8376C8.97371 10.7016 9.0501 10.5172 9.0501 10.3249V2.3499Z" />
            </svg>
            {width > 640 && <span
              className={`self-center text-xl font-semibold whitespace-nowrap ${dark ? "text-white" : "text-neutral-900"
                }`}
            >
              {"Hello, " + userName}
            </span>}
          </div>
          <div className="inline-flex justify-between items-center absolute mx-auto right-0 space-x-4 p-2 min-w-fit w-1/3 pr-6">
            {width >= 640 && <SearchBar />}
            <Bell active={notifNumber} onClick={toggleModal} />
            <UserAvatar
              icon={icon}
              notifications={notifNumber} />
          </div>
        </div>
      </header>
    </Fragment>
  );
}

export default TopNavbar;
